import { computed } from "vue";
import { useStore } from "vuex";

export const useTenantEntityManager = () => {
  const store = useStore();

  const storeSelectedEntity = computed(
    () => store.getters?.["programManager/getSelectedEntityView"]
  );

  const setSelectedEntityView = (tenantEntity) => {
    const newTenantEntity = { ...tenantEntity };
    store.commit("programManager/setSelectedEntityView", newTenantEntity);
  };

  const getSelectedEntityView = computed(() => storeSelectedEntity.value ?? {});

  setSelectedEntityView(getSelectedEntityView.value);

  return {
    getSelectedEntityView: getSelectedEntityView,
    setSelectedEntityView,
  };
};
